import {
  PAGE_TOOLBAR,
  ACTIVATE_ANALISI,
  RESET_DISPLAY_MODE,
} from "../actions/types";

const initialState = {
  page: "Maps",
  mode: "Display",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PAGE_TOOLBAR:
      return {
        ...state,
        page: action.payload,
      };
    case ACTIVATE_ANALISI:
      return {
        ...state,
        mode: "Analysis",
      };
    case RESET_DISPLAY_MODE:
      return {
        ...state,
        mode: "Display",
      };
    default:
      return state;
  }
}
